import { render, staticRenderFns } from "./ServiceDetailModal.vue?vue&type=template&id=4b195122&scoped=true"
import script from "./ServiceDetailModal.vue?vue&type=script&lang=js"
export * from "./ServiceDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ServiceDetailModal.vue?vue&type=style&index=0&id=4b195122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b195122",
  null
  
)

export default component.exports